<template>
	<div>
		<app-inbox-loading v-if="isDataLoading" />
		<div v-else>
			<b-row v-if="false">
				<b-col>
					<b-button class="btn-close-page float-right mb-2" @click="$emit('closePage')" v-b-tooltip.hover title="Close"><b-icon-x /></b-button>
				</b-col>
			</b-row>
			<b-card header="Work Order Process" class="mb-3">
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-work-order-number" label-cols-lg="12" label="Work Order Process Number" size="sm" :model.sync="model.workOrderProcessNumber" :isEditable="false" />
						<!-- <app-label label-cols-lg="12" size="sm" type="generatednumber" label="Work Order Process Number" :model="model.workOrderProcessNumber" /> -->
						<app-input-datepicker :min="minDate" id="fieldset-production-date" label-cols-lg="12" label="Production Date" size="sm" :model.sync="model.productionDate" :isRequired="true" :state="validateState('productionDate')" :errorMessage="getErrorMessage(errorMessage.productionDate, 'productionDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="false" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete ref="processTypeInput" :options="processTypes" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Process Type Code" id="fieldset-process-type" size="sm" :model.sync="model.processTypeId" :isRequired="true" :state="validateState('processTypeId')" :errorMessage="getErrorMessage(errorMessage.processTypeId, 'processTypeId')"   :selected="model.processType != null ? model.processType.code : ''" @input="getProcessTypes" :isSelectMethodExists="true" @onSelectMethod="onProcessTypeChange" :isEditable="false" :isUpdatable="false" />
						<app-input-textbox id="fieldset-process-type" label-cols-lg="12" label="Process Type" size="sm" :model.sync="model.processType.name" :isEditable="false" />
						<!-- <app-label label-cols-lg="12" size="sm" label="Process Type" :model="(model.processType != null) ? model.processType.name : null"  /> -->
						<app-input-textbox id="fieldset-line-code" label-cols-lg="12" label="Line Code" size="sm" :model.sync="model.lineCode.name" :isEditable="false" />
						<!-- <app-input-combobox-autocomplete :options="lines" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Line Code" id="fieldset-line-code" size="sm" :model.sync="model.lineCodeId" :isRequired="true" :state="validateState('lineCodeId')" :errorMessage="getErrorMessage(errorMessage.lineCodeId, 'lineCodeId')"   :selected="model.lineCode != null ? model.lineCode.code : ''" @input="getLineCodeByProcessType" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedLineCode" :isUpdatable="true"/> -->
						<!-- <app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Document Status" id="fieldset-document-status" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" @change="updateData" :isEditable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDocumentStatus" :isUpdatable="true"/> -->
					</b-col>
				</b-row>
			</b-card>

		<app-table-input 
			title = "Work Order Process Detail"
			:bordered="true" :items="workOrderProcessDetails" 
			:fields="fieldsWorkOrderProcessDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByWorkOrderProcessDetail" 
			:sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive	
			@editButtonMethod="editRowDataWorkOrderProcessDetail"	
			@deleteButtonMethod="deleteRowDataWorkOrderProcessDetail"	
			@showPopupAddMethod="addDataWorkOrderProcessDetail()"	
			@showPopupUploadMethod="showPopupUploadWorkOrderProcessDetail()"
			@downloadMethod="downloadWorkOrderProcessDetail()"
			@addFromClipboardMethod="addFromClipboardWorkOrderProcessDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardWorkOrderProcessDetail()"
			:showActionButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadWorkOrderProcessDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowWorkOrderProcessDetailFilter = !isShowWorkOrderProcessDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowWorkOrderProcessDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select id="input-work-order-process-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterWorkOrderProcessDetail.partId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Line Machine">
					<v-select id="input-work-order-process-detail-machine-table" append-to-body label="code" :options="machines" :value="filterWorkOrderProcessDetail.machineId" :reduce="item => item.id" v-model="filterWorkOrderProcessDetail.machineId" @search="getMachines" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty (Plan)">
					<b-form-input id="input-work-order-process-detail-qty-plan-table" v-model="filterWorkOrderProcessDetail.qtyPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Hour (Plan)">
					<b-form-input id="input-work-order-process-detail-hour-plan-table" v-model="filterWorkOrderProcessDetail.hourPlan" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-work-order-process-detail-remark-table" v-model="filterWorkOrderProcessDetail.remark" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( workOrderProcessDetailPageSize * (currentWorkOrderProcessDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(part)="row">
				<!-- <app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-work-order-process-detail-part-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.partPartNumber != null ? row.item.partPartNumber : row.item.part  ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isEditable="false"  :nolabel="true" /> -->
				<app-label label-cols-lg="12" size="sm" label="Part Code" :model="(row.item.partPartNumber != null) ? row.item.partPartNumber : (row.item.part != null) ? row.item.part.partNumber : null"  />
			</template>
			<template v-slot:cell(partName)="row">
				<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.partPartName != null) ? row.item.partPartName : (row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(partClassification)="row">
				<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(row.item.part != null) ? (row.item.part.partClassification != null) ? row.item.part.partClassification.code : null : null"  />
			</template>
			<template v-slot:cell(standarPackagingQty)="row">
				<app-label label-cols-lg="12" size="sm" label="Standard Packaging Qty" :model="(row.item.part != null) ? row.item.part.standarPackagingQty : null"  />
			</template>
			<template v-slot:cell(nextProcess)="row">
				<app-label label-cols-lg="12" size="sm" label="NextProcess" :model="(row.item.billOfProcess != null) ? (row.item.billOfProcess.nextProcess != null) ? row.item.billOfProcess.nextProcess.name : null : null"  />
			</template>
			<template v-slot:cell(machine)="row">
				<app-label label-cols-lg="12" size="sm" label="Machine Line" :model="(row.item != null) ? row.item.listMachine : null"  />
				<!-- <app-input-combobox-autocomplete :options="machines" optionsLabel="code" optionsKey="id" :id="'input-work-order-process-detail-machine-' + row.index" label-cols-lg="12" label="Line Machine" size="sm" :model.sync="row.item.machineId" :state="validateState('machineId')" :errorMessage="getErrorMessage(errorMessage.machineId, 'machineId')"  @change="saveInputWorkOrderProcessDetail(row.item)" :selected="row.item.machine != null ? row.item.machine.code : ''"  @input="getMachines" :loading="isMachineComboLoading"  :isEditable="false"  :nolabel="true" /> -->
			</template>
			<template v-slot:cell(sph)="row">
				<app-label label-cols-lg="12" size="sm" label="Stroke Per Hour" :model="(row.item.machine != null) ? row.item.machine.sph : null"  />
			</template>
			<template v-slot:cell(qtyPlan)="row">
				<app-label label-cols-lg="12" size="sm" label="Qty (Plan)" :model="row.item.qtyPlan"  />
				<!-- <app-input-textbox :id="'input-work-order-process-detail-qty-plan-' + row.index" label-cols-lg="12" label="Qty (Plan)" size="sm" :model.sync="row.item.qtyPlan" :state="validateState('qtyPlan')" :errorMessage="getErrorMessage(errorMessage.qtyPlan, 'qtyPlan')"   @change="saveInputWorkOrderProcessDetail(row.item)" :isEditable="false"  :nolabel="true" /> -->
			</template>
			<template v-slot:cell(hourPlan)="row">
				<app-input-textbox :id="'input-work-order-process-detail-hour-plan-' + row.index" label-cols-lg="12" label="Hour (Plan)" size="sm" :model.sync="row.item.hourPlan"   @change="saveInputWorkOrderProcessDetail(row.item)" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(customer)="row">
				<app-label label-cols-lg="12" size="sm" label="Customer" :model="(row.item.part != null) ? (row.item.part.customer != null) ? row.item.part.customer.code : null : null"  />
			</template>
			<template v-slot:cell(remark)="row">
				<app-label label-cols-lg="12" size="sm" label="Remark" :model="row.item.remark"  />
				<!-- <app-input-textarea :id="'input-work-order-process-detail-remark-' + row.index" label-cols-lg="12" label="Remark" size="sm" :model.sync="row.item.remark"  @change="saveInputWorkOrderProcessDetail(row.item)" :isEditable="false"  :nolabel="true" /> -->
			</template>

								
			<template v-slot:form-add-detail>
				<WorkOrderProcessDetailInput 
					:model="modelWorkOrderProcessDetail"
					:openPopup="isShowPopupWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataWorkOrderProcessDetail"/>
			</template>
			<template v-slot:upload-detail>
					<WorkOrderProcessDetailUpload
					:openPopup="isShowPopupUploadWorkOrderProcessDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataWorkOrderProcessDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentWorkOrderProcessDetailPage"
				:total-rows="totalWorkOrderProcessDetailRow"
				:per-page="workOrderProcessDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
			<b-overlay :show="isBusy" no-wrap></b-overlay>
			<Portal to="app-inbox-button">
				<app-approval-button
					@approveMethod="submitAction" 
					:showApproveButton="true" 
					approveButtonTitle="Submit Request" 
					@revisionMethod="editDraftAction"
					:showRevisionButton="true"
					revisionButtonTitle="Edit Draft"
					@rejectMethod="discardAction" 
					:showRejectButton="true" 
					rejectButtonTitle="Discard Request" 
				/>
			</Portal>
		</div>
	</div>
</template>
<style>
	.input-label-detail {
		font-weight: normal !important;
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';

import AppInputTextarea from '@/components/AppInputTextarea';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import ProcessType from '@/models/ProcessType/ProcessType';
import ProcessTypeFilter from '@/filters/ProcessType/ProcessTypeFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import BillOfProcess from '@/models/BillOfProcess/BillOfProcess';
import BillOfProcessFilter from '@/filters/BillOfProcess/BillOfProcessFilter';
import Machine from '@/models/Machine/Machine';
import MachineFilter from '@/filters/Machine/MachineFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import WorkOrderProcessDetailInput from '@/views/WorkOrderProcess/WorkOrderProcessDetailInput';
import WorkOrderProcessDetailUpload from '@/views/WorkOrderProcess/WorkOrderProcessDetailUpload';

import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import AppApprovalButton from '@/components/AppApprovalButton';

export default {
	props: 
		{
			selectedModelId: {
				default: "",
				type: String
			},
			selectedModel: {
				default: null,
				type: Object
			},
			successAction: {},
			inboxType: {
				default: "",
				type: String
			}
		}
	,
	components : {
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		WorkOrderProcessDetailInput,
		WorkOrderProcessDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail, 
		PopupRouterView,
		AppApprovalButton,
		AppInputTextarea,

		PopupRouterViewApprovalDetail, 
		PopupRouterViewDetail,
		PopupRouterView,
		AppApprovalButton,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			productionDate: {required},
			lineCodeId: {required},
			processTypeId: {required},
		}
	},

	data() {
		return {
			errorMessage : {
				productionDate: { required : "Production Date is Required."},
				lineCodeId: { required : "Line Code is Required."},
				processTypeId: { required : "Process Type is Required."},
			},

			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			isShowDataDetailFilter: false,
			isDownloadDataDetail: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			backroute: '',
			approvalConfiguration: {},
			fieldsWorkOrderProcessDetail: [
				//{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"part": { "class" : "th-part normal-text first-child", "label" : "Part Number", key: 'part', sortable: true }}, 
				{"partName": { "class" : "th-part-name normal-text", "label" : "Part Name", key: 'partName', sortable: true }}, 
				{"partClassification": { "class" : "th-part-classification normal-text last-child", "label" : "Part Classification", key: 'partClassification', sortable: true }}, 
				{"standarPackagingQty": { "class" : "th-standar-packaging-qty normal-text d-stack-none", "label" : "Standard Packaging Qty", key: 'standarPackagingQty', sortable: true }}, 
				{"nextProcess": { "class" : "th-next-process normal-text d-stack-none", "label" : "NextProcess", key: 'nextProcess', sortable: true }}, 
				{"machine": { "class" : "th-machine normal-text d-stack-none", "label" : "Line Machine", key: 'machine', sortable: true }}, 
				{"sph": { "class" : "th-sph normal-text d-stack-none", "label" : "Stroke Per Hour", key: 'sph', sortable: true }}, 
				{"qtyPlan": { "class" : "th-qty-plan normal-text d-stack-none", "label" : "Qty (Plan)", key: 'qtyPlan', sortable: true }}, 
				{"hourPlan": { "class" : "th-hour-plan normal-text d-stack-none", "label" : "Hour (Plan)", key: 'hourPlan', sortable: true }}, 
				{"customer": { "class" : "th-customer normal-text d-stack-none", "label" : "Customer", key: 'customer', sortable: true }}, 
				{"remark": { "class" : "th-remark normal-text d-stack-none", "label" : "Remark", key: 'remark', sortable: true }}, 
				//{"documentStatus": { "class" : "th-document-status d-stack-none", "label" : "Document Status", key: 'documentStatus', sortable: true }}, 
				//{"lotNo": { "class" : "th-lot-no d-stack-none", "label" : "LotNo", key: 'lotNo', sortable: true }}, 
				//{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelWorkOrderProcessDetail : {},
			isShowPopupWorkOrderProcessDetail : false,
			isShowPopupUploadWorkOrderProcessDetail : false,
			filterWorkOrderProcess : null,
			currentWorkOrderProcessPage : 1,
			workOrderProcessPageSize: 10,
			sortByWorkOrderProcess: '',
			sortDescWorkOrderProcess: '',
			filterWorkOrderProcessDetail : null,
			currentWorkOrderProcessDetailPage : 1,
			workOrderProcessDetailPageSize: 10,
			sortByWorkOrderProcessDetail: '',
			sortDescWorkOrderProcessDetail: '',
			sortingByWorkOrderProcessDetail: [],
			workOrderProcessDetails : [],
			workOrderProcessDetailId : '',
			totalWorkOrderProcessDetailRow : 0,
			isShowWorkOrderProcessDetailFilter: false,
			isDownloadWorkOrderProcessDetail: false,
			parts: [],
			billOfProcesss: [],
			machines: [],
			documentStatuss: [],
			lines: [],
			lineCodes: [],
			isLineCodeComboLoading: false,
			processTypes: [],
			processTypes: [],
			isProcessTypeComboLoading: false,
			backroute: '',
			isLineComboLoading: false,
			isProcessTypeComboLoading: false,
			isDocumentStatusComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isPartComboLoading: false,
			isBillOfProcessComboLoading: false,
			isMachineComboLoading: false,
			minDate: new Date(),

		}
	},
	methods : {
		async setSelectedProcessType(item) {
			if(item == undefined || item == null) {
				this.model.processTypeId = null;
				this.model.processType = null;
				this.model.processTypeName = null;
			} else {
				this.model.processTypeId = item.id;
				this.model.processType = item;
				this.model.processTypeName = item.name;
			}
			this.$forceUpdate();
			// await this.updateData();
		},
		updateWhenChangeProcessType : async function(itemValue,showPopupForLine=false) {
			await this.setSelectedProcessType(itemValue);
			this.model.lineCodeId = null;
			this.model.lineCode = null;
			console.log('masuk sini 1')
			await this.updateData();
			console.log('masuk sini 2')
			let item = null
			let processTypeObj = null
			if (itemValue!=null && itemValue!=undefined) {
				item = itemValue.id;
				processTypeObj = this.processTypes.filter(function(processType){ return processType.id == item; });
			}
			this.model.processType = processTypeObj!=null && processTypeObj.length > 0 ? processTypeObj[0] : null;

			this.model.processTypeName = processTypeObj!=null && processTypeObj.length > 0 ? processTypeObj[0].name : null;
			await this.onLineCodeChange(showPopupForLine);
			this.getLineCodeByProcessType();
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		onProcessTypeChange : async function(itemValue) {
			if (itemValue!=null && itemValue!=undefined && this.model.processTypeId==itemValue.id) {
				return;
			}
			if(this.model.lineCodeId) {
				let messageInfo = 'Line akan di reload, apakah anda ingin melanjutkan ?';
				if(await this.showPopupWithMessage(messageInfo)){
					await this.updateWhenChangeProcessType(itemValue);
				}
			}else{
				await this.updateWhenChangeProcessType(itemValue);

			}
		},
		async onLineCodeChange(isShowPopupConfirmationLineChange=true) {
			if(!this.workOrderProcessDetails.length>0) return;
			let messageInfo = 'Machine Line akan direset, apakah anda ingin melanjutkan ?';
			if (isShowPopupConfirmationLineChange ){
				let resultPopup = await this.showPopupWithMessage(messageInfo);
				if(!resultPopup){
					return;
				}
			}
			// await this.workOrderProcessDetails.forEach(item => {
			// 	item.machine = null;
			// 	item.machineId = null;
			// 	item.machineCode = null;

			// 	 this.saveInputWorkOrderProcessDetail(item);
			// });
			await this.getWorkOrderProcessDetails();
			//this.getWorkOrderProcess(this.modelId);
			this.lines = [];
			this.machines = [];

			this.getLineCodeByProcessType();
		},
		getLineCodeByProcessType : async function(input) {
			this.lineCodeState = false;
			this.$forceUpdate();

			let filter = new LineFilter();
			filter.processTypeId = this.model.processTypeId;
			if (input != undefined) {
				filter.code = input;
			}
			if (filter.processTypeId === undefined || filter.processTypeId === null || filter.processTypeId === '') {
				this.lineCodes = [];
			} else {
				await Line.getList(this, filter, null, 0, 10)
					.then(result => {
						this.lineCodes = [];
						if (result != null) {
							this.lineCodes = result.data
							this.lines = result.data

						}
					})
					.catch(error => {
						this.lineCodes = [];
						this.lines = [];
					});
			}

			this.lineCodeState = true;
			this.$forceUpdate();
		},
		getWorkOrderProcess : async function(id) {
			this.isDataLoading = true;
			await this.getWorkOrderProcessDetails();

			
			WorkOrderProcess.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				//WorkOrderProcess.getApprovalConfigurationInput(this, result.approvalInstanceId).then(result => { this.approvalConfiguration = result; this.isDataLoading = false; }).catch(() => { this.isDataLoading = false; });
				this.isDataLoading = false;
			}).catch(error => { this.isDataLoading = false; });
		},
		downloadData() {
			this.isDownloadWorkOrderProcess = true;
			this.filterWorkOrderProcess.id = this.modelId;
			WorkOrderProcess.downloadDataDetail(this, this.filterWorkOrderProcess).then(result => {
				this.isDownloadWorkOrderProcess = false;
			}).catch(error => { this.isDownloadWorkOrderProcess = false; })
		},
		getWorkOrderProcessDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterWorkOrderProcessDetail);
			if (this.modelId == null) return;
			filter.workOrderProcessId = this.modelId;
			//filter.draftMode = "0";
			if (this.sortByWorkOrderProcessDetail != null) {
				this.sortingByWorkOrderProcessDetail[this.sortByWorkOrderProcessDetail] = this.sortDescWorkOrderProcessDetail;
			}
			let currentPage = (this.currentWorkOrderProcessDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalWorkOrderProcessDetailRow + 1;
				let page = Math.ceil(totalData/this.workOrderProcessDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.workOrderProcessDetailPageSize = 0;
			// disable paging end
			await WorkOrderProcessDetail.getList(this, filter, this.sortingByWorkOrderProcessDetail, currentPage , this.workOrderProcessDetailPageSize).then(result => {
				this.currentWorkOrderProcessDetailPage = currentPage + 1;
				this.workOrderProcessDetails = result.data;

				this.workOrderProcessDetails.forEach(item => {
					console.log("item", item);
					let partName = item.part.partName
					let partNumber = item.part.partNumber
					if(item.part.partReference) {
						partName = item.part.partName + " / " + item.part.partReference.partName;
						partNumber = item.part.partNumber + " / " + item.part.partReference.partNumber;
					}

					console.log("partName", partName);
					console.log("partNumber", partNumber);

					item.partPartNumber = partNumber;
					item.partPartName = partName;
				});

				this.totalWorkOrderProcessDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getWorkOrderProcesss : async function(input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			this.isWorkOrderProcessComboLoading = true;
			WorkOrderProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcesss = result.data
				}
				this.isWorkOrderProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			filter.notPartClassificationCodes = "RM,COMPONENT";
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfProcesss : async function(input) {
			let filter = new BillOfProcessFilter();
			if (input != undefined) {
				filter.partNumberId = input;
			}
			this.isBillOfProcessComboLoading = true;
			return await BillOfProcess.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					return result.data;
				}
				this.isBillOfProcessComboLoading = false;
			})
			.catch(error => {});
		},
		getMachines : async function(input) {
			let filter = new MachineFilter();
			if(this.model.lineCodeId) {
				filter.lineCodeId = this.model.lineCodeId;
			} else {
				this.$bvToast.toast("Silahkan pilih line code terlebih dahulu", {
					title: 'Missing Line Code',
					variant: 'danger',
					solid: true,


					autoHideDelay: 3000 // Optional: Mengatur durasi pesan
				});
				
				return;
			}
			if (input != undefined) {
				filter.code = input;
			}
			this.isMachineComboLoading = true;
			await Machine.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.machines = result.data
				}
				this.isMachineComboLoading = false;
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
				this.isDocumentStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getLines : async function(input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Line.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.lines = result.data
				}
			})
			.catch(error => {});
		},
		async setSelectedLineCode(item) {
			if(item == undefined || item == null) {
				this.model.lineCodeId = null;
				this.model.lineCode = null;
			} else {
				this.model.lineCodeId = item.id;
				this.model.lineCode = item;
			}
			await this.onLineCodeChange();
			this.$forceUpdate();
			await this.updateData();
		},
		getProcessTypes : async function(input) {
			let filter = new ProcessTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			ProcessType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.processTypes = result.data
				}
			})
			.catch(error => {});
		},
		async updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then(async (results) => {
				if (id != '' && id != null && id != undefined) {
					await WorkOrderProcess.updateData(this, model, id);
				}
			});
		},

		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		editDraftAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'workorderprocesscreateinboxrequest', params : { id: id } });
			}
		},
		submitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.submitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		approveAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to approve this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.approveApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		rejectAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to reject this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.rejectApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		reviseAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to ask for revision for this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
							this.isBusy = true;
							WorkOrderProcess.reviseApprovalData(this, model, id).then(result => {
								this.isDataCommited = true;
								this.$emit("successAction");
								this.isBusy = false;
							}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		editRequestAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.editRequest(this, id).then(result => {
					if (result != null) {
						if (result.id != null && result.id != "") {
							this.$router.push({ name: 'workorderprocesscreateinboxrequest', params : { id: result.id } });
						}
					}
					this.isCreateBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		discardAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to discard this data?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderProcess.discardData(this, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				WorkOrderProcess.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		cancelAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Are you sure want to cancel this request?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e=>{
					if(e){
						this.isBusy = true;
						WorkOrderProcess.cancelApprovalData(this, model, id).then(result => {
							this.isDataCommited = true;
							this.$emit("successAction");
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						return;
					}
				});
			}
		},
		onHidden() {
			// this.getWorkOrderProcesss();
		},
		addRowDataWorkOrderProcessDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				} else {
					model.workOrderProcessId =  this.modelId;
					WorkOrderProcessDetail.createData(this, model)
					.then(result => {
						this.getWorkOrderProcessDetails(true);
						this.isShowPopupWorkOrderProcessDetail = false;
					})
				}
			}
		},
		async editRowDataWorkOrderProcessDetail(id) {
			this.workOrderProcessDetailId = id;
			this.isShowPopupWorkOrderProcessDetail = true; 
		},
		async deleteRowDataWorkOrderProcessDetail(id) {
			WorkOrderProcessDetail.deleteData(this, id).then(result => { this.getWorkOrderProcessDetails(); });
		},
		async resetDataWorkOrderProcessDetail() {
			this.workOrderProcessDetailId = "";
			this.isShowPopupWorkOrderProcessDetail = true;
		},
		async addDataWorkOrderProcessDetail() {
			WorkOrderProcessDetail.createData(this, { workOrderProcessId: this.modelId })
			.then(result => {
				this.getWorkOrderProcessDetails(true);
			})
		},
		async addFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.addFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});
		},
		async replaceFromClipboardWorkOrderProcessDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, workOrderProcessId: this.modelId });
				});
				WorkOrderProcessDetail.replaceFromClipboard(this, parts).then(result => { this.getWorkOrderProcessDetails() });
			});   
		},
		showPopupUploadWorkOrderProcessDetail() {
			this.isShowPopupUploadWorkOrderProcessDetail = true;
		},
		uploadDataWorkOrderProcessDetail(modalEvent, newDatas) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
		},
		downloadWorkOrderProcessDetail(modalEvent) {
			this.isDownloadWorkOrderProcessDetail = true;
			this.filterWorkOrderProcessDetail.workOrderProcessId = this.modelId;
			WorkOrderProcessDetail.downloadDataDetail(this, this.filterWorkOrderProcessDetail).then(result => {
				this.isDownloadWorkOrderProcessDetail = false;
			}).catch(error => { this.isDownloadWorkOrderProcessDetail = false; })
		},
		saveInputWorkOrderProcessDetail : async function(item) {
			if (this.workOrderProcesss != null && this.workOrderProcesss != undefined  && this.workOrderProcesss.length > 0) {
				item.workOrderProcess = this.workOrderProcesss.find(q => q.id == item.workOrderProcessId);
			}
			item.part = this.parts.find(q => q.id == item.partId);
			if (item.part!= null && this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				
				let partName = item.part!=null ? item.part.partName : "";
				let partNumber = item.part!=null ? item.part.partNumber : "";
				if(item.part!=null && item.part.partReference) {
					partName = item.part.partName + " / " + item.part.partReference.partName;
					partNumber = item.part.partNumber + " / " + item.part.partReference.partNumber;
				}
				item.partPartNumber = partNumber;
				item.partPartName = partName;

				let partId = item.part.id;
				let billOfProcess = await this.getBillOfProcesss(partId);
				
				if(billOfProcess.length == 0) {
					let message = 'Tidak ditemukan data Bill Of Process atas Part ' + item.part.partNumber +', silahkan konfigurasi bill of process terlebih dahulu';
					this.$bvToast.toast(message, {
						title: 'Bill Of Process not found',
						variant: 'danger',
						solid: true,
						autoHideDelay: 3000 // Optional: Mengatur durasi pesan
					});

					item.billOfProcess = null;
					item.billOfProcessId = null;
				} else {
					item.billOfProcess = billOfProcess[0];
					item.billOfProcessId = billOfProcess[0].id;
				}
			}else{
				// this.resetRefferenceDataWorkOrderProcessDetail(item);
			}
			
			let id = item.id;
			let promises = Array();

			// await Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					await WorkOrderProcessDetail.updateData(this, item, item.id).then(result=>{this.getWorkOrderProcessDetails(false)});
				}
			// });
		},

		resetModal(modalType) {
			this.isShowPopupUploadWorkOrderProcessDetail = false; 
			this.isShowPopupWorkOrderProcessDetail = false; 
			if (modalType == 'WorkOrderProcessDetail') {
				this.getWorkOrderProcessDetails();
			}

			//this.showPopupCopyData = false; 
			//this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowWorkOrderProcessDetailFilter = true;

			}
		},
	},
	beforeMount() {
		//this.filterWorkOrderProcess = new WorkOrderProcessFilter();
//this.filterWorkOrderProcess = new WorkOrderProcessFilter();
		this.filterWorkOrderProcessDetail = new WorkOrderProcessDetailFilter();
		//this.getWorkOrderProcesss();
		//this.getParts();
		//this.getBillOfProcesss();
		//this.getMachines();
		//this.getDocumentStatuss();
		//this.getLines();
		//this.getProcessTypes();


		//this.getWorkOrderProcesss();
	},
	async mounted() {
		if (this.selectedModel != null && this.selectedModel != "") {
			this.modelId = this.selectedModel.id;
			this.model = this.selectedModel;
			this.getDataDetails();
		} else if (this.selectedModelId != null && this.selectedModelId != "") {
			this.modelId = this.selectedModelId;
			this.getWorkOrderProcess(this.selectedModelId);
		}
	},
	computed: {
		disableRejectRevise() {
			if (this.model.approvalRemarks == undefined || this.model.approvalRemarks == null || this.model.approvalRemarks == '') return true;
			return false;
		},
	},
	watch : {
		selectedModelId(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue;
				this.getWorkOrderProcess(newValue);
			}
		},
		selectedModel(newValue, oldValue) {
			if (newValue != oldValue) {
				this.modelId = newValue.id;
				this.model = newValue;
				this.getWorkOrderProcessDetails();
			}
		},
		sortByWorkOrderProcessDetail : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		sortDescWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		currentWorkOrderProcessDetailPage: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		workOrderProcessDetailPageSize : {
			handler: function() {
				this.getWorkOrderProcessDetails();
			}
		},
		filterWorkOrderProcessDetail: {
			handler: function() {
				this.getWorkOrderProcessDetails();
			},
			deep: true,
		},


	},
}
</script>
